import {Injectable, OnDestroy} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {ContentScope} from '@shared/commands/command-base';
import {ConversationComponentName} from './collaboration.constants';
import {CreateChatConversationAction} from './collaboration.action';
import {CollaborationState} from './collaboration.reducer';
import {Store} from '@ngrx/store';
import {CreateChatConversationCommand} from './collaboration.command';
import {CommandService} from '@core/services/command.service';
import {
  CreateArrangementCommand,
  CreatePreArrangementCommand
} from '../../../dac6-reporter/commands/dac6-reporter.command';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Router} from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {catchError, map, mergeMap, takeUntil} from 'rxjs/operators';
import {of, Subject} from 'rxjs';
import {RightSidebarWaitScreenService} from "@core/services/right-sidebar-waitcreen.service";
import {Configuration} from "@shared/models/configuration";
/**
 * Created by jahidul.hasan on 12/12/2019.
 */
@Injectable()
export class CollaborationHashtagService implements OnDestroy{
  ngUnsubscribe = new Subject<void>();
  constructor(private dialogService: DialogService,
              private snackbarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private rightSidebarWaitScreenService: RightSidebarWaitScreenService,
              protected commandService: CommandService,
              private router: Router,
              private collaborationStore: Store<CollaborationState>) {
  }

  takeActionOnHashtag(hashTag: string, roles: any) {
    if (hashTag === 'DAC6') {
      this.getDac6CaseDialog(roles);
    }
  }

  getDac6CaseDialog(roles: any) {
    {
      const contextId = '[COMPANY_ID]-chat';
      const sourceType = 'DAC6';
      const dialogModel: DialogModel = DialogModel.create(
        'Assign to a DAC6 Case',
        'Dac6CaseHashTagDialogComponent', {},
        '800px',
        '800px'
      );
      this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
        if (res.action === 'OK') {
          //console.log('after hashtag dialog, Expecitng caseId:', res);
          if (res.data.input.caseType === 'existing') {
            this.getChatForThisCase(res.data.input.caseGuid, res.data.input.caseId, contextId, sourceType, roles);
          } else if (res.data.input.caseType === 'new') {
            this.createCase(contextId, sourceType, roles);
          }
        }
      });
    }
  }

  createCase(contextId, sourceType, roles) {
    const dialogModel: DialogModel = DialogModel.create(
      'Create Case',
      'CreateCaseDialogComponent', {'caseType': 'PreArrangement', disableTypeChange: false},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'PreArrangement':
            this.addPreArrangement(res.data.input.title, contextId, sourceType, roles);
            break;
          case 'Arrangement':
            this.addArrangement(res.data.input.title, contextId, sourceType, roles);
            break;
        }
      }

    });
  }

  createChat(contextId, title, sourceType, conversationId, sourceInfoDictionary, roles) {
    const rolesArray = [];
    if (roles) {
      roles.forEach(item => {
        rolesArray.push({'user': item.user, permissionType: item.permission.permissionType, 'roleTypes': [1, 2, 3]});
      });
    }
    const createChatConversationCommand = new CreateChatConversationCommand(
      contextId,
      title,
      true,
      0,
      sourceType,
      rolesArray,
      true,
      conversationId,
      sourceInfoDictionary
    );
    this.rightSidebarWaitScreenService.showRightSidebarWaitScreen();
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  addArrangement(title: string, contextId, sourceType, roles) {
    this.fuseSplashScreenService.show();
    const command = new CreateArrangementCommand(title);
    command.endpointUrl = `${Configuration.getConfig('Dac6Api')}Visitor/CreateArrangement`;
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state &&  state.Payload && state.Payload.FieldValues) {
        this.fuseSplashScreenService.hide();
        this.snackbarService.showInformation('Case Added Successfully.');
        this.getChatForThisCase(state.Payload.FieldValues.CaseGUID, state.Payload.FieldValues.CaseId, contextId, sourceType, roles);
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackbarService.showError('Case Added Failed.');
    });
  }

  addPreArrangement(title: string, contextId, sourceType, roles) {
    this.fuseSplashScreenService.show();
    const command = new CreatePreArrangementCommand(title);
    command.endpointUrl = `${Configuration.getConfig('Dac6Api')}Visitor/CreatePreArrangement`;
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state &&  state.Payload && state.Payload.FieldValues) {
        this.fuseSplashScreenService.hide();
        this.snackbarService.showInformation('Case Added Successfully.');
        this.getChatForThisCase(state.Payload.FieldValues.CaseGUID, state.Payload.FieldValues.CaseId, contextId, sourceType, roles);
      }
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackbarService.showError('Case Added Failed.');
    });
  }

  getChatForThisCase(caseGuid, caseId, contextId, sourceType, roles) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: caseGuid,
        caseId: caseId
      }
    };
    this.createChat(contextId, caseId, sourceType, caseGuid, sourceInfoDictionary, roles);
  }

  navigateToCase(sourceInfo) {
    if (sourceInfo && sourceInfo.sourceInfoDictionary && sourceInfo.sourceInfoDictionary.length >= 2) {
      if (sourceInfo.sourceInfoDictionary[0] && sourceInfo.sourceInfoDictionary[0].Value) {
        this.router.navigate([`dac6-reporter/overview/case/${sourceInfo.sourceInfoDictionary[0].Value}`]);
      }
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
